// Generated by scripts/write-version.js — do not edit by hand.
// Change the version in package.json (or run `yarn bump`) instead.
export const APP_VERSION = '1.0.12'

export default APP_VERSION
